
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsSizeDialog extends Serenity.EntityDialog<CsSizeRow, any> {
        protected getFormKey() { return CsSizeForm.formKey; }
        protected getIdProperty() { return CsSizeRow.idProperty; }
        protected getLocalTextPrefix() { return CsSizeRow.localTextPrefix; }
        protected getNameProperty() { return CsSizeRow.nameProperty; }
        protected getService() { return CsSizeService.baseUrl; }
        protected getDeletePermission() { return CsSizeRow.deletePermission; }
        protected getInsertPermission() { return CsSizeRow.insertPermission; }
        protected getUpdatePermission() { return CsSizeRow.updatePermission; }

        protected form = new CsSizeForm(this.idPrefix);
        protected afterLoadEntity() {
            super.afterLoadEntity();

            var SizeId = Q.tryFirst(CsSkuRow.getLookup().items,x => x.SizeId == this.entity.SizeId);
            console.log(SizeId);
            if(SizeId != null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
            var Plucheck = Q.tryFirst(CsPluRow.getLookup().items, x=> x.SizeId == this.entity.SizeId);  
            console.log(Plucheck);
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
        }

       
    }
}